import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BASE_URL } from '../../requestMethod';
import HandleTracking from '../orderComponent/checkEnum';
import OrderProgressbar from '../OrderProgressbar';
import { trackFailure, trackStart, trackSuccess } from "../../redux/basketRedux";
import './order.css';
;



export default function OrderDetails({ order }) {
    const dispatch = useDispatch();
    const trackBasket = useSelector((state) => state.track);
    const mss = encodeURIComponent("hello world");
    useEffect(() => {
        setTrack(order.track)
        dispatch(trackSuccess(order.track))
        console.log(order)
    }, [order]);

    const [track, setTrack] = useState(0);

    const trac = HandleTracking(trackBasket.track);
    const user = useSelector((state) => state.user.currentUser);
    const handleProceed = async () => {
        try {

            let request = [];
            track < 6 && setTrack(track + 1);
            console.log(track);
            let t = track < 6 && track + 1;
            request.push({ trackStatus: t, basketId: order.id });
            console.log(request);
            const res = await axios.post(`${BASE_URL}Basket/setTrackLevel`, request, {
                mode: 'no-cors',
                headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
            });
            if (res.data.status) { dispatch(trackSuccess(t)); }

            //console.log("data", res.data);

        }
        catch (err) {
            dispatch(trackFailure(err))
            console.log(err)
        }

    }
    const handleBack = () => {
        track >= 0 && setTrack(track - 1);
    }
    const sendProgressLink = () => {
        console.log(trackBasket.track)
        let msg = "";
        if(order.paymentStatus ==0){
            msg=`Oops! Looks like you cancelled the payment while trying to order your goods. \n Kindly *reply here* with *'Proceed'* to recieve payment guide. \n OR \n *reply here* with *'Cancel'* to cancel the order. \n Thank you for Choosing us`;
            
        }
        else{
        
        switch (trackBasket.track) {
            case 0:
                msg = "Your order has been recieved and in process. We will keep you posted until your goods are delivered to you. Thank you for Choosing us";
                break;
            case 1:
                msg = "We are already in the market purchasing your goods on your behalf. We will keep you posted until your goods are delivered to you. Thank you for Choosing us";
                break;
            case 2:
                msg = "Your order will be shipped soon. We are making ready your order. We will keep you posted until your goods are delivered to you. Thank you for Choosing us";
                break;
            case 3:
                msg = "Your order has been shipped, it should get to you as soon as possible. We will keep you posted until your goods are delivered to you. Thank you for Choosing us";
                break;
            case 4:
                msg = "Congrats your order is already at the pick up station you chose. Kindly reply here with a review of your experience. We value your feedback. We will keep you posted until your goods are delivered to you. Thank you for Choosing us";
                break;
            case 5:
                msg = "Your order has been delivered successfully. Thank you for Choosing us";
                break;
            default:
                break;

        }
    }
        const number = order.mobilePhone.replace(order.mobilePhone[0], '+234');
        const message = encodeURIComponent(`${msg}`);
        window.open(`https://api.whatsapp.com/send?phone=${number}&text=${message}`);

    }
    const sendPaymentLink = () => {
        const transNum = order.trackingId;
        const number = order.mobilePhone.replace(order.mobilePhone[0], '+234');

        const msg = encodeURIComponent(`Please click on the link to proceed to payment \n https://afeexclusive.github.io/oilandgas/externalPay.html?trackid=${transNum}`);
        window.open(`https://api.whatsapp.com/send?phone=${number}&text=${msg}`);


    }


    return (
        <div className="card">
            <div className="card-body">
                <h4 className="card-title"><u>Order Details</u></h4>
                {/* 08024141094 */}
                <OrderProgressbar trackOrder={track} />

                <p>{trac}</p>


                {/* <select className="form-control" value={order.track == 0}>
                    <option value="">---</option>
                    <option option={0}>Pending</option>
                    <option option={1}>We are in Market</option>
                    <option option={2}>Packaging</option>
                    <option option={3}>On Transit</option>
                    <option option={4}>Ready to be Picked</option>
                    <option option={5}>Delivered</option>
                    <option option={6}>Treated</option>
                </select> */}

                <div className="btn-group" role="group" aria-label="Basic example">
                    {/* <button type="button" className="btn btn-secondary" onClick={() => handleBack(order.track)}>
                        <i className="mdi mdi-arrow-left-bold-circle d-block mb-1" /> Back </button> */}
                    <button type="button" className="default-btn btn-warning" onClick={() => handleProceed(order.track)}>
                        <i className="mdi mdi-arrow-right-bold-circle " /> Proceed </button>
                </div>

                <div className="d-flex mt-2">
                    {/* <img src="assets/images/faces/face3.jpg" className="img-sm rounded-circle me-3" alt="image" /> */}
                    <div className="mb-0 flex-grow">
                        <h3 className="me-2 mb-2">{order.customerName}</h3>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item"><span>Address:</span>  {order.address}</li>
                            <li className="list-group-item"><span>Phone:</span> <b>{order.mobilePhone}</b></li>
                            <li className="list-group-item"><span>Email:</span> <b>{order.email}</b></li>
                            <li className="list-group-item"><span>Gateway:</span> <b>{order.gateway}</b></li>
                            <li className="list-group-item"><span>Transaction No:</span> <b>{order.transactionNumber}</b></li>
                            <li className="list-group-item"><span>Total Price:</span><b>NGN {order.orderAmount}</b> </li>
                        </ul>

                        <div className='flex-wrap justify-content-center row ' style={{ display: "flex" }}>

                           <div className=' col-12 col-md-6 '><button type="button" className="  default-btn btn-info  " onClick={sendPaymentLink}>Payment Link</button></div> 
                           <div className=' col-12 col-md-6 mt-2  mt-md-0 mt-lg-0 '><button type="button" className="  default-btn btn-success ">Confirm Payment</button></div> 
                           <div className=' col-12 col-md-6 mt-2 '><button type="button" className=" default-btn btn-secondary " onClick={sendProgressLink}>Send Progress</button></div> 
                        </div>
                        {/* <a href={`https://api.whatsapp.com/send?phone=+2347060936988&text=${mss}`} target="_blank">Send Message</a> */}
                    </div>

                </div>
                <div className="row">
                    <div className="col-12 grid-margin">
                        <div className="card mt-3">
                            <span>Date Created: {order.dateCreated}</span>
                            <div className="card-body">
                                <h4 className="card-title">Product Ordered ({order.orderCount})</h4>
                                {order.orders ? <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th> </th>
                                                <th> Name </th>
                                                <th> Price </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {order.orders.map(item => (
                                                <tr key={item.id}>
                                                    <td>
                                                        {/* <img src="assets/images/faces/face1.jpg" className="me-2" alt="image" /> */}
                                                        <img src={item.productImage} className="me-2" alt="image" />
                                                    </td>
                                                    <td> {item.productName} </td>
                                                    <td>NGN {item.amount} </td>
                                                </tr>
                                            ))}


                                        </tbody>
                                    </table>
                                </div> : (
                                    <h3>No Order for this basket</h3>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div >
    );
}
